import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpClientModule, HttpClient } from '../../node_modules/@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ApiProvider } from '../providers/api/api';
import { CommonFunctionsProvider } from '../providers/common-functions/common-functions';
import { DateFunctionsProvider } from '../providers/date-functions/date-functions';

import { EMS_Web } from './app.component';
import { TranslationProvider } from '../providers/translation/translation';

@NgModule({
  declarations: [
    EMS_Web
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(EMS_Web, {mode: "md"}),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    EMS_Web
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiProvider,
    CommonFunctionsProvider,
    DateFunctionsProvider,
    TranslationProvider
  ]
})
export class AppModule {}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


// WEBPACK FOOTER //
// ./src/app/app.module.ts